import { DomainAction } from '../index'

const domain = "Questionnaire"

export const Questionnaire = {
    getAll: new DomainAction(domain, 'GetAll', DomainAction.methods.get),
    getSingle: new DomainAction(domain, '', DomainAction.methods.get),
    create: new DomainAction(domain, '', DomainAction.methods.post),
    update: new DomainAction(domain, '', DomainAction.methods.put),
    delete: new DomainAction(domain, '', DomainAction.methods.delete),
}